import React from 'react';
import { ArrowLeft } from 'lucide-react';
import './staff.css';

// Shown only to signed-in Manager users, pinned to the bottom of the shop. The switch flips between the Manager view
// (staff controls visible) and the public view (exactly what a customer sees); the bar itself is all that remains.
// A labelled on/off switch for the bar.
export function StaffSwitch({ label, checked, disabled = false, onChange, title }) {
  return <button type="button" role="switch" aria-checked={checked} disabled={disabled} title={title} className={`store-staff-toggle ${checked ? 'on' : ''}`} onClick={() => onChange(!checked)}>
    <span className="track"><span className="knob" /></span>{label}
  </button>;
}

export default function StaffBar({ session, view, onView, onEdit, onManager, visitors = null, children }) {
  const publicView = view === 'public';
  return <div className={`store-staff-bar ${publicView ? 'is-public' : ''}`} role="region" aria-label="Staff controls">
    {onManager && <button type="button" className="store-staff-action store-staff-back" onClick={onManager} title="Back to Manager"><ArrowLeft aria-hidden="true" />Manager</button>}
    <div className="store-staff-switch" role="group" aria-label="View">
      <button type="button" aria-pressed={!publicView} onClick={() => onView('manager')}>Manager view</button>
      <button type="button" aria-pressed={publicView} onClick={() => onView('public')}>Public view</button>
    </div>
    {!publicView && <>
      {children}
      {visitors && <span className="store-staff-visitors" title="People who visited the Store (counted without cookies)">{visitors.today.visitors.toLocaleString()} today · {visitors.days30.visitors.toLocaleString()} in 30 days</span>}
      {onEdit && <button type="button" className="store-staff-action primary" onClick={onEdit}>Edit store</button>}
      <span className="store-staff-who" title={session.user.name}>{session.user.initials || session.user.name}</span>
    </>}
  </div>;
}
